import { Global } from '@mantine/core';
import { FC } from 'react';

const GlobalStyles: FC = () => {
  return (
    <Global
      styles={{
        'html, body': {
          height: '100%',
          overflow: 'hidden',
          background: '#f8f9fa',
        },
        '#root': {
          height: '100%',
          overflow: 'hidden',
        },
      }}
    />
  );
};

export { GlobalStyles };
